import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import 'virtual:svg-icons-register'
import App from '@/App.vue'
import router from '@/router'
import pinia from '@/stores'
import VueScrollTo from 'vue-scrollto'
import 'virtual:uno.css'
import '@/styles/app.less'
import '@/styles/var.less'
import { gameIndexApi } from '@/api/home'
import { i18n } from '@/utils/i18n'
import SvgIcon from '@/components/SvgIcon/index.vue'

/**
 * skinTheme 换肤默认主题
 */
import '@/styles/skinTheme/202601/theme.less' // 换肤默认主题

// Vant 桌面端适配
import { Lazyload } from 'vant'
import '@vant/touch-emulator'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

// const GoogleCore = 'G-4E7GB0EWP3'
// // Google Analytics 初始化 - 仅用于事件跟踪
// const gtagScript = document.createElement('script')
// gtagScript.async = true
// gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GoogleCore}` // 替换为你的Measurement ID
// document.head.appendChild(gtagScript)
// window.dataLayer = window.dataLayer || []
// function gtag() {
//   window.dataLayer.push(arguments)
// }
// gtag('js', new Date())
// // 禁用自动页面浏览跟踪，只启用事件跟踪
// // gtag('config', GoogleCore, {
// //   send_page_view: false, // 关键：禁用自动页面浏览跟踪
// // }) // 替换为你的Measurement ID
// gtag('config', GoogleCore)
// // 全局注册 GA 事件跟踪函数 - 专门用于跟踪注册等自定义事件
// window.trackEvent = function (eventName, eventParams = {}) {
//   if (typeof gtag === 'function') {
//     gtag('event', eventName, eventParams)
//   }
// }

const scrollOptions = {
  container: 'body', //滚动的容器
  duration: 500, //滚动时间
  easing: 'ease', //缓动类型
  offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true, // 是否要在y轴上滚动
}

const app = createApp(App)
const head = createHead()
app.use(Lazyload)
app.use(VueScrollTo, scrollOptions)
app.use(head)
app.use(router)
app.use(pinia)
app.use(i18n)
app.component('SvgIcon', SvgIcon)

async function initializeApp() {
  // 选用当前主题
  try {
    document.documentElement.setAttribute('data-theme', 'theme-color')
  } catch (error) {
    console.log('选用当前主题错误:', error)
  }

  // 获取本地配置并设置缓存
  const response = await fetch('/config.json')
  const localConfig = await response.json()
  if (localConfig) {
    localStorage.setItem('lang', localConfig.localLanguage) // 因为目前没有国际化切换，所以直接设置语言为本地配置
    try {
      localStorage.setItem('localConfig', JSON.stringify(localConfig))
      // 获取初始配置并设置初始配置缓存
      const baseUrl = localConfig.baseApiUrl
      const response2 = await fetch(`${baseUrl}/initConfig`, {
        headers: {
          appid: btoa(localConfig.appid),
        },
      })
      if (!response2.ok) throw new Error(`HTTP error! status: ${response2.status}`)
      const data = await response2.json()
      localStorage.setItem('initConfig', JSON.stringify(data.data))
      app.mount('#app')
    } catch (error) {
      console.log('appid初始化出错 - error:', error)
    }
  } else {
    console.log('appid初始化出错')
  }

  // // 获取游戏数据
  // try {
  //   const versionModal = { version: '' }
  //   const { data, code } = await gameIndexApi(versionModal)
  //   if (data.version) {
  //     localStorage.setItem('version', data.version)
  //   }
  //   if (code == 1) {
  //     sessionStorage.setItem('games', JSON.stringify(data))
  //   }
  // } catch (error) {
  //   console.log('获取游戏数据- error:', error)
  // }
}

// 修改 router.isReady() 调用
router.isReady().then(() => {
  // 确保只调用一次初始化
  initializeApp()
})
